export default __webpack_public_path__ + "static/media/move.6b629424.svg";